
import { useState } from 'react';

// Hook for fullscreen react
function useFullScreen () {
    const [fullScreen, setFullScreen] = useState(false);

    const toggleFullScreen = () => {
        
        !fullScreen ? document.querySelector("#root").requestFullscreen() : document.exitFullscreen()
        
        setFullScreen(!fullScreen);
    }
    
    const toggleFullScreenF11 = (event) => {
        if(event.key != "F11") {
            return;
        }

        // Kill event if F11 to replace fullscreen browser call by our own
        event.preventDefault();
        toggleFullScreen();
    }

    return { toggleFullScreen, toggleFullScreenF11 }
}

export default useFullScreen